(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3708],{

/***/ 73708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hero001": function() { return /* binding */ Hero001; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87900);
/* harmony import */ var _Hero001_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66913);
/* harmony import */ var _Hero001_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Hero001_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Hero001 = function(param) {
    var payload = param.payload;
    var ref;
    var headline = (ref = payload === null || payload === void 0 ? void 0 : payload.headline) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var description = (ref1 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var linkText = (ref2 = payload === null || payload === void 0 ? void 0 : payload.linkText) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    var link = (ref3 = payload === null || payload === void 0 ? void 0 : payload.page) !== null && ref3 !== void 0 ? ref3 : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Hero001_module_scss__WEBPACK_IMPORTED_MODULE_2___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Hero001_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Heading1 */ .nL, {
                        className: (_Hero001_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
                        color: "dark",
                        children: headline
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Paragraph */ .nv, {
                        className: (_Hero001_module_scss__WEBPACK_IMPORTED_MODULE_2___default().description),
                        color: "dark",
                        children: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Hero001_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["top-circle"]),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Hero001_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["inside-circle"]),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .PageLink */ .H_, {
                                slug: link.slug,
                                className: (_Hero001_module_scss__WEBPACK_IMPORTED_MODULE_2___default().link),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_Hero001_module_scss__WEBPACK_IMPORTED_MODULE_2___default().arrow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
                                            className: (_Hero001_module_scss__WEBPACK_IMPORTED_MODULE_2___default().icon),
                                            name: "large_arrow_right"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Paragraph */ .nv, {
                                        color: "brand",
                                        appearance: "bigger",
                                        children: linkText
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Hero001);


/***/ }),

/***/ 66913:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hero001_wrapper__oZ5pu","content":"Hero001_content__Fs6YM","title":"Hero001_title__Sag7z","description":"Hero001_description__QIdzS","top-circle":"Hero001_top-circle__kT4O9","inside-circle":"Hero001_inside-circle__O8_3T","link":"Hero001_link__KGJSR","arrow":"Hero001_arrow__9yILF","icon":"Hero001_icon__WnjwR"};

/***/ })

}]);